import * as React from 'react';

import { Colors, Ratings } from '@notino/react-styleguide';

import {
  BazaarvoiceRatingPlaceholder,
  BazaarvoiceRatingsDiv,
  Wrapper,
} from './styled';

interface BazaarvoiceRatingsProps {
  productCode: string;
}

export const BazaarvoiceRatings = ({
  productCode,
}: BazaarvoiceRatingsProps) => {
  return (
    <Wrapper>
      <BazaarvoiceRatingPlaceholder>
        <Ratings
          ratingId="loading-skeleton-id"
          rating={0}
          size={16}
          numReviews={0}
          foreground={Colors.primary}
          microdata={false}
        />
      </BazaarvoiceRatingPlaceholder>

      <BazaarvoiceRatingsDiv
        id="bv-reviews-test"
        data-bv-show="rating_summary"
        data-bv-product-id={productCode}
      />
    </Wrapper>
  );
};
